/**
 * @Author: WeiZisen
 * @Date: 2021-03-11 15:06:59
 * @LastEditors: WeiZisen
 * @LastEditTime: 2021-03-11 15:07:49
 * @Description: 请输入一段描述
 * @FilePath: \bim-vue-template\src\common\plugins\echarts.js
 */
import Echarts from 'echarts'

import BimChart from 'vue-echarts'
import theme from './vab-echarts-theme.json'

BimChart.registerTheme('vab-echarts-theme', theme)
export default BimChart
